import appLogger from "../utils/app-logger";
import { apiService } from "../services/base-api-service";
import { endPoints, getOrchestrationServiceEndPoint } from "../services/api-constants";
import { getAuthHeader, readCookie } from "../utils/helpers";

class OrchestrationService {
  OrchestrationService(url) {
    return getOrchestrationServiceEndPoint(url);
  }
  checkoutProcess(data) {
    appLogger.log("inside checkout process ");
    const createOrchestrationProcessEndpoint = this.OrchestrationService(`${endPoints.orchestrationService.CHECKOUT}`);
    return apiService.post(createOrchestrationProcessEndpoint, data, getAuthHeader());
  }

  checkoutProcess3DS(data) {
    appLogger.log("inside checkout process ");
    const createOrchestrationProcessEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.CHECKOUT_3DS}`
    );
    return apiService.post(createOrchestrationProcessEndpoint, data, getAuthHeader());
  }

  getBillingInfo(userGuid, locale) {
    appLogger.log("inside getBillingInfo ");
    const bilingInfoEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.BILLING_INFO.replace(":userGuid", userGuid).replace(":localeVal", locale)}`
    );
    return apiService.get(bilingInfoEndpoint, null, getAuthHeader());
  }

  cancelUserByUserGuid(data, userGUID) {
    appLogger.log("inside cancelUserByUserGuid ");
    const cancelUserEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.CANCEL_USER.replace(":userGuid", userGUID)}`
    );
    return apiService.put(cancelUserEndpoint, data, getAuthHeader());
  }

  restartSubscription(data, userGUID) {
    appLogger.log("inside cancelUserByUserGuid ");
    const restartSubscriptionEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.RESTART_SUB.replace(":userGuid", userGUID)}`
    );
    return apiService.post(restartSubscriptionEndpoint, data, getAuthHeader());
  }

  setConfirmationinCB(userGUID) {
    appLogger.log("inside setConfirmationinCB ");
    const confirmationinCBEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.SET_CONFIRMATION.replace(":userGuid", userGUID)}`
    );
    return apiService.put(confirmationinCBEndpoint, JSON.stringify("true"), getAuthHeader());
  }

  getUserPlan(userGuid, data) {
    appLogger.log("inside getUserPlan ");
    const PlanEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.GET_USER_PLANS.replace(":userGuid", userGuid)}`
    );
    return apiService.post(PlanEndpoint, data, getAuthHeader());
  }
  getGatewayAbtestResponse(cardtoken, currency, portal) {
    appLogger.log("inside getGatewayAbtestResponse ");
    const gatewayABtestEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.GATEWAY_ABTEST.replace(":cardtoken", cardtoken)
        .replace(":currency", currency)
        .replace(":portal", portal)}`
    );
    return apiService.get(gatewayABtestEndpoint, null, getAuthHeader());
  }
  isCardInBadBins(bin, portal, currencyCD, country) {
    appLogger.log("inside getGatewayAbtestResponse ");
    const gatewayABtestEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.BAD_BINS.replace(":token", bin)
        .replace(":currency", currencyCD)
        .replace(":portal", portal)
        .replace(":CountryCd", country)}`
    );
    return apiService.get(gatewayABtestEndpoint, null, getAuthHeader());
  }
  getDynamicPhoneNumber(portalCd, currencyCD) {
    const gatewayABtestEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.DYNAMIC_PHONE_NUMBER.replace(":currencycd", currencyCD).replace(
        ":portalcd",
        portalCd
      )}`
    );
    return apiService.get(gatewayABtestEndpoint, null, getAuthHeader());
  }
  addPaymentErrorSendMail(data) {
    const addPaymentErrorEndpoint = this.OrchestrationService(`${endPoints.orchestrationService.ADD_PAYMENT_ERROR}`);
    return apiService.post(addPaymentErrorEndpoint, data, getAuthHeader());
  }
  getPaymentError(userGuid) {
    const gatewayABtestEndpoint = this.OrchestrationService(
      `${endPoints.orchestrationService.GET_PAYMENT_ERROR.replace(":userguid", userGuid)}`
    );
    return apiService.get(gatewayABtestEndpoint, null, getAuthHeader());
  }
}

export default new OrchestrationService();
